
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { ModuleItemProps } from ".";
import { loading, find } from "store/module";

interface ApiModuleFindByIdInputProps {
    id: number;
}

type ApiModuleFindOutputProps = OutputBaseProps<{ item: ModuleItemProps; }, ApiModuleFindByIdInputProps>

export const apiModuleFindById = async (data: ApiModuleFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiModuleFindOutputProps>(`/api/module/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiModuleFindByCodeInputProps {
    code: string;
}

export const apiModuleFindByCode = async (data: ApiModuleFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiModuleFindOutputProps>(`/api/module/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};